import { HttpEventType, HttpResponse } from '@angular/common/http';
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { ReportFileUploadService } from 'app/core/common/services/report-file-upload-service';
import { Inward } from 'app/modules/admin/transactions/inwards/inwards.types';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { set } from 'lodash';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-upload-images',
    templateUrl: './upload-images.component.html',
    styleUrls: ['./upload-images.component.scss'],
})
export class UploadImagesComponent implements OnInit {
    @Input() inward: Inward;
    @Input() report: InwardReport;
    @Input() fileName: string;

    googleDrivePath: string;

    selectedFiles?: FileList;
    selectedFileNames: string[] = [];

    progressInfos: any[] = [];
    message: string[] = [];

    preview: any;
    imageInfos?: Observable<any>;
    imageUploaded: boolean = false;

    constructor(
        private uploadService: ReportFileUploadService,
        private alertService: AlertMessageService,
        private _sanitizer: DomSanitizer,
        private cdRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.googleDrivePath = this.inward.googleDrivePath;
        if (this.fileName && this.report) {
            // Assuming fileName is like 'ValuationPhoto1' and report property is 'valuationPhoto1'
            const propertyName = this.fileName.charAt(0).toLowerCase() + this.fileName.slice(1);
            const photoData = (this.report as any)[propertyName];

            if (photoData) {
                this.preview =
                    this._sanitizer.bypassSecurityTrustResourceUrl(
                        'data:image/png;base64,' + photoData
                    );
            }
        }
    }

    selectFiles(event: any): void {
        this.imageUploaded = false;
        this.message = [];
        this.preview = null;
        this.progressInfos = [];
        this.selectedFileNames = [];
        this.selectedFiles = event.target.files;
        if (this.selectedFiles && this.selectedFiles[0]) {
            const numberOfFiles = this.selectedFiles.length;
            for (let i = 0; i < numberOfFiles; i++) {
                const reader = new FileReader();

                reader.onload = (e: any) => {
                    this.preview = e.target.result;
                };

                reader.readAsDataURL(this.selectedFiles[i]);

                this.selectedFileNames.push(this.selectedFiles[i].name);
            }
        }
    }

    upload(file: File): void {
        this.imageUploaded = true;
        this.cdRef.detectChanges();
        this.progressInfos[0] = { value: 0, fileName: this.fileName };

        const formData: FormData = new FormData();
        formData.append('ReportFile', file);
        formData.append('FileName', this.fileName);
        formData.append('ReportId', this.report.id.toString());
        if (this.googleDrivePath) {
            formData.append('GoogleDrivePath', this.googleDrivePath);
        }
        if (file) {
            this.uploadService.upload(formData).subscribe(
                (event: any) => {
                    if (event.type === HttpEventType.UploadProgress) {
                        this.progressInfos[0].value = Math.round(
                            (100 * event.loaded) / event.total
                        );
                    } else if (event instanceof HttpResponse) {
                        const msg = file.name + ': Successful!';
                        this.alertService.success(msg);
                        this.imageInfos = this.uploadService.getFiles();
                        this.imageUploaded = true;
                        this.cdRef.detectChanges();
                    }
                },
                (err: any) => {
                    this.progressInfos[0].value = 0;
                    this.imageUploaded = false; // Enable button again on failure
                    this.cdRef.detectChanges();
                    let msg = file.name + ': Failed!';
                    this.alertService.error(msg);
                }
            );
        }
    }

    // removeImage(fileInput: HTMLInputElement): void {
    //     (this.report as any)[this.fileName] = null;
    //     this.preview = null;
    //     this.selectedFiles = undefined;
    //     this.selectedFileNames = [];
    //     this.imageUploaded = false;
    // }

    uploadFiles(): void {
        this.message = [];
        if (this.selectedFiles) {
            this.upload(this.selectedFiles[0]);
        }
    }
}
